import { CircleAlert } from "lucide-react";
import { CaseStageEnum } from "../../../api/caseStages";

interface CaseStageProgressionDetailsProps {
  nextStage: CaseStageEnum;
}

const CaseStageProgressionDetails: React.FC<
  CaseStageProgressionDetailsProps
> = ({ nextStage }) => {
  let owner = "";
  let nextStageDetails = "";

  switch (nextStage) {
    case CaseStageEnum.FWD_AUTH_CASE_REVIEW:
      owner = "Forwarding Authority";
      nextStageDetails = "Forwarding Authority Case Review";
      break;

    case CaseStageEnum.CREATOR_INFORMATION_ADDITION:
      owner = "Case Creator";
      nextStageDetails = "Case Creator Information Addition";
      break;

    case CaseStageEnum.FRMD_ADMIN_CASE_REVIEW:
      owner = "FRMD Admin";
      nextStageDetails = "FRMD Admin Case Review";
      break;

    case CaseStageEnum.FWD_AUTH_INFORMATION_ADDITION:
      owner = "Forwarding Authority";
      nextStageDetails = "Forwarding Authority Information Addition";
      break;

    case CaseStageEnum.FRMD_ADMIN_DO_ASSIGNMENT:
      owner = "FRMD Admin";
      nextStageDetails = "Dealing Officer Assignment";
      break;

    case CaseStageEnum.DO_NOMINATE_IO_APP_AUTH:
      owner = "Dealing Officer";
      nextStageDetails = "Investigating Officer Appointing Authority Assignment";
      break;

    case CaseStageEnum.FRMD_ADMIN_IO_APP_AUTH_REVIEW:
      owner = "FRMD Admin";
      nextStageDetails = "Investigating Officer Appointing Authority Review";
      break;

    case CaseStageEnum.IO_APP_AUTH_ASSIGN_IO:
      owner = "Investigating Officer Appointing Authority";
      nextStageDetails = "Investigating Officer Assignment";
      break;

    case CaseStageEnum.IO_ASSIGNED:
      owner = "Investigating Officer";
      nextStageDetails = "Case Investigation";
      break;

    case CaseStageEnum.IO_SUBMIT_IR:
      owner = "Investigating Officer";
      nextStageDetails = "Case Investigation";
      break;  

    case CaseStageEnum.IO_APP_AUTH_SUBMIT_ASSESSMENT:
      owner = "IO Appointing Authority";
      nextStageDetails = "Review Investigation Report & Add Observations";
      break;  

    case CaseStageEnum.POST_IR_ASSESSMENT_SUBMITTED:
      owner = "FRMD";
      nextStageDetails = "Review Recommendations from IO Appointing Authority";
      break;      

    default:
      break;
  }

  if (owner === "" || nextStageDetails === "") return null;

  return (
    <div className="w-[485px] min-h-[112px] rounded-lg bg-[#F5F5F5] p-3 flex flex-col gap-1">
      <div className="flex flex-row gap-1">
        <div className="font-sans text-sm font-medium leading-5 tracking-normal text-[#4B5563] mb-1">
          Next Stage:
        </div>
        <div className="font-sans text-sm font-normal leading-5 tracking-normal text-[#737373] truncate">
          {nextStageDetails}
        </div>
      </div>

      <div className="flex flex-row gap-1 mb-1.5">
        <div className="font-sans text-sm font-medium leading-5 tracking-normal text-[#4B5563] mb-1">
          Next Owner:
        </div>
        <div className="font-sans text-sm font-normal leading-5 tracking-normal text-[#737373] truncate">
          {owner}
        </div>
      </div>

      <div className="w-full border-t border-[#E5E5E5] mb-1.5" />

      <div className="flex justify-start items-center gap-2">
        <CircleAlert
          className="flex-shrink-0 text-[#4B5563]"
          style={{ width: 16, height: 16, strokeWidth: 2 }}
        />
        <span className="font-sans text-xs font-normal leading-4 tracking-normal text-[#4B5563]">
          Once confirmed, the case will be forwarded to the next user.
        </span>
      </div>
    </div>
  );
};

export default CaseStageProgressionDetails;
